<template>
  <v-row class="type-insurance-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12">
          <h2 class="mb-3">{{ typeOfInsuranceIntroducer?.title }}</h2>
          <p class="mb-3">
            {{ typeOfInsuranceIntroducer?.description }}
          </p>
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex justify-space-between ma-0">
            <v-col
              class="type-insurance__item flex"
              v-for="(typeInsurance, index) in typeInsurancesList"
              :key="index"
            >
              <div class="img-wrapper d-flex justify-center align-center">
                <img
                  :src="require(`@/assets/images/${typeInsurance.icon}`)"
                  :alt="typeInsurance?.icon"
                />
              </div>
              <h3>
                {{ typeInsurance?.title }}
              </h3>
              <p v-html="typeInsurance?.description"></p>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="text-center">
          <v-btn
            :ripple="false"
            depressed
            rounded
            color="mustard"
            x-large
            class="font-weight-bold font-18 text-uppercase mx-auto"
            @click="$emit('openCreateLLQuoteDialog')"
            aria-label="Get a new quote"
          >
            Get a new quote
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {
  HOME_TYPE_OF_INSURANCE,
  TYPE_INSURANCES,
} from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageTypeOfInsurance",
  props: {
    typeOfInsuranceIntroducer: {
      type: Object,
      default: () => HOME_TYPE_OF_INSURANCE,
    },
    typeInsurancesList: {
      type: Array,
      default: () => TYPE_INSURANCES,
    },
  },
};
</script>
<style lang="scss" scoped>
.type-insurance-wrapper {
  background-color: #eff0f0 !important;
  padding: 43px 0 28px 0;
  .type-insurance__item {
    background-color: #fff !important;
    padding: 28.5px 60px 18px 60px;
    border-radius: 10px;
    text-align: center;
    margin-right: 32px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    &:last-child {
      margin-right: 0;
    }
    .img-wrapper {
      min-height: 86.5px;
      height: 86.5px;
    }
    h3 {
      padding-bottom: 14px;
    }
    p {
      text-align: left;
    }
  }
}
@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .type-insurance-wrapper {
    margin-top: 0 !important;

    .type-insurance__item {
      flex-basis: auto;
      margin-right: 0;
      &:not(:last-child) {
        margin-bottom: 25px;
      }
    }
    padding-bottom: 28px;
  }
}
</style>
